import React, { useState } from "react";
import { useSpring, animated } from "react-spring";

import classes from "./BottomNav.module.css";
import Button from "./Button/Button";
import ListPlusIcon from "../../../assets/icons/list-plus.svg";
import CloseIcon from "../../../assets/icons/x.svg";

export default function BottomNav() {
  const [clicked, setClicked] = useState(false);

  const open = useSpring({
    display: clicked ? "none" : "flex",
    rotate: clicked ? 90 : 0,
    config: { delay: 500, duration: 500 },
  });

  const close = useSpring({
    display: clicked ? "flex" : "none",
    rotate: clicked ? 90 : 0,
    config: { delay: 500, duration: 500 },
  });

  const width = useSpring({
    width: clicked ? "97%" : "5%",
    height: clicked ? "99%" : "50%",
    display: clicked ? "flex" : "none",
    borderRadius: clicked ? "1rem" : "50%",
    config: { delay: 500, duration: 500 },
  });

  return (
    <div className={classes.BottomNav}>
      <Button
        style={open}
        icon={ListPlusIcon}
        open
        clicked={() => setClicked(true)}
      />
      <Button
        style={close}
        icon={CloseIcon}
        clicked={() => setClicked(!clicked)}
      />

      <animated.ul className={classes.BottomNavList} style={width}>
        Links
      </animated.ul>
    </div>
  );
}
